import {
	Overlay as AriaOverlay,
	type PositionProps,
	useOverlay,
	useOverlayPosition,
} from "@react-aria/overlays";
import { useRef } from "react";

type Props<T> = {
	targetRef: React.RefObject<T | null>;
	isOpen: boolean;
	onClose: () => void;
	children: React.ReactNode;
	placement?: PositionProps["placement"];
	offset?: PositionProps["offset"];
	shouldFlip?: PositionProps["shouldFlip"];
};

export const Overlay = <T extends HTMLElement>({
	targetRef,
	isOpen,
	onClose,
	children,
	placement = "bottom start",
	offset = 8,
	shouldFlip = true,
}: Props<T>) => {
	const overlayRef = useRef<HTMLDivElement>(null);

	const { overlayProps } = useOverlay(
		{
			isOpen: isOpen,
			onClose: onClose,
			isDismissable: true,
		},
		overlayRef,
	);

	const { overlayProps: overlayPositionProps } = useOverlayPosition({
		targetRef,
		overlayRef,
		placement,
		offset,
		shouldFlip,
	});

	return (
		<AriaOverlay>
			<div {...overlayPositionProps} {...overlayProps} ref={overlayRef}>
				{children}
			</div>
		</AriaOverlay>
	);
};
